import React from 'react';

interface FormTextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string;
}

export const FormTextArea: React.FC<FormTextAreaProps> = ({
  label,
  error,
  className = '',
  ...props
}) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-400 mb-1">
        {label}
      </label>
      <textarea
        className={`w-full bg-black/20 border ${
          error ? 'border-red-500' : 'border-white/10'
        } rounded-lg px-3 py-2 text-white focus:outline-none focus:border-neon-green h-24 resize-none ${className}`}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-red-500">{error}</p>
      )}
    </div>
  );
};